import React from "react";
import {TextField} from "@mui/material";
import useLockScrollOnInputFocus from "./useLockScrollOnInputFocus.js";

const ExtendedTextField = ({ ...props }) => {
  useLockScrollOnInputFocus();

  return (
    <TextField {...props} />
  );
};

export default ExtendedTextField;
